import React from "react";
import { MyGlobalContext } from "../../Context";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";

const CartArticle = ({ id, name, img, quantity }) => {
  const { remove, localCart, add, handleRemoveQuantity } = MyGlobalContext();
  const price = parseFloat((id / 5000).toFixed(1));
  return (
    <article data-aos="zoom-in-up" className="cart-article">
      <img src={img} alt={name} className="cart-image" />
      <div className="information-cart-div">
        <h2 className="h2">Name: {name}</h2>
        <h4>Price: ${price} </h4>
        <div className="flex items-center">
          <button
            onClick={() => handleRemoveQuantity(id)}
            className="cart-plusminus-btn"
          >
            <AiOutlineMinus />
          </button>
          <h2 className="mt-2 mx-2">{quantity}</h2>
          <button onClick={() => add(id)} className="cart-plusminus-btn">
            <AiOutlinePlus />
          </button>
        </div>
        <button onClick={() => remove(id)}>Remove</button>
      </div>
    </article>
  );
};

export default CartArticle;
